import { QueryKey } from '@tanstack/react-query';

// [endpoint, params]
export type AxiosQueryKey<P extends Record<string, unknown> = Record<string, unknown>> =
    | [string]
    | [string, P];

export function isAxiosQueryKey(queryKey: QueryKey): queryKey is AxiosQueryKey {
    const [endpoint, params] = queryKey;
    return (
        typeof endpoint == 'string' &&
        typeof params === 'object' &&
        params !== null &&
        !Array.isArray(params)
    );
}
